module.exports = __webpack_public_path__ + "img/correct.e847f8ac.svg";